import { NavLink } from 'react-router-dom';
import { FcReading } from "react-icons/fc";

const NavBar = () => {
  const paddingY = 'py-2';

  const beforeS = `font-roboto focus:shadow-none text-base py-4 hover:before:bg-slate-300 before:h-[0px] before:w-full before:top-[-7px] before:absolute before:current:bg-green-600`;
  
  return (
    <nav>
      <ul className={`bg-white pl-5 ${paddingY} border-b-2 border-gray-100 flex items-center gap-4`}>
        <li className="relative m-0 flex mr-4">
          <p className="text-green-500 text-2xl font-roboto font-thin italic">Five</p>
          <p className="text-2xl font-roboto font-bold text-green-600">Prayer</p>
        </li>
        <div className="container-nav flex flex-1 gap-9">
          <li className="relative m-0">
            <NavLink className={`current:text-green-600 ${beforeS}`} to="/" end>
              Welcome
            </NavLink>
          </li>
          <div className="container-settings flex ml-5 flex-1 gap-4">
            <li className="relative m-0">
              <NavLink className={`current:text-green-600 ${beforeS}`} to="/prayersettings" end>
                Prayer Settings
              </NavLink>
            </li>
            <li className="relative m-0">
              <NavLink className={`current:text-green-600 ${beforeS}`} to="/hijra">
                Hijra Calendar
              </NavLink>
            </li>
            <li className="relative m-0">
              <NavLink className={`current:text-green-600 ${beforeS}`} to="/customizing">
                Customizing
              </NavLink>
            </li>
            <li className="relative m-0">
              <NavLink className={`current:text-green-600 ${beforeS}`} to="/moresettings">
                More Settings
              </NavLink>
            </li>
          </div>
          <div className="container-docs flex mr-7 gap-3">
            <li className="relative m-0">
              <NavLink className={`current:text-green-600 ${beforeS}`} to="/documentation">
                Docs
                <FcReading className="absolute top-[-2px] right-[-15px] text-green-600" /> {/* Position the icon */}
                <span className="absolute top-[-13px] right-[-10px] h-2 w-2">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75"></span>
                  <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-blue-500"></span>
                </span>
              </NavLink>
            </li>
          </div>
        </div>
      </ul>
    </nav>
  );
};

export default NavBar;
